module.exports = __webpack_public_path__ + "img/78.3f0a64d1.jpg";